
import {Component, Vue} from 'vue-property-decorator';
import {currentUserModule, exportsModule, studyModule} from "@/store";
import {MdbsCore} from "@/api/tsclient";
import DataExchangeTable from "@/components/exports/DataExchangeTable.vue";
import DataExchangeFileDto = MdbsCore.DataExchangeFileDto;
import Rights = MdbsCore.Rights;
import QueriesExports from "@/views/admin/exports/QueriesExports.vue";
import {startDownload} from "@/auxillary/export.helper";
import {DateTime} from "luxon";
import DateInputMenu from "@/components/common/DateInputMenu.vue";
import FinalExport from "@/views/admin/exports/FinalExport.vue";

@Component({
  components: {FinalExport, DateInputMenu,QueriesExports, DataExchangeTable}
})
export default class AuditTrail extends Vue {

  showSnackbar: boolean = false;
  fromDate: Date | undefined = new Date();
  toDate: Date | undefined = new Date();

  get loading() {
    return exportsModule.isLoading;
  }

  generateStatusExport() {
    this.showSnackbar = true;

    exportsModule.generateStatusExport({studyId: studyModule.study.id})
  }

  generateChangesExport() {
    this.showSnackbar = true;

    exportsModule.generateChangesExport({studyId: studyModule.study.id})
  }

  generateCsvExport() {
    this.showSnackbar = true;

    exportsModule.generateCsvExport({studyId: studyModule.study.id})
  }

  get statusExportsFiles() {
    return exportsModule.statusExportsFiles;
  }

  get changesExportsFiles() {
    return exportsModule.changesExportsFiles;
  }

  get csvExportsFiles() {
    return exportsModule.csvExportsFiles;
  }

  async mounted() {
    const today = DateTime.now()
        .setZone("Europe/Berlin")
        .set({hour: 0, minute: 0});
    const yesterday = today
        .plus({ days: -1 });

    this.toDate = today.toJSDate();
    this.fromDate = yesterday.toJSDate();

    if (this.canGetStatusExportFiles) {
      await this.refreshStatusExports();
    }

    if (this.canGetChangesExportFiles) {
      await this.refreshChangesExports();
    }
  }

  async refreshStatusExports() {
    await exportsModule.getStatusExportsFiles({fromDate: undefined});
  }

  async refreshChangesExports() {
    await exportsModule.getChangesExportsFiles({fromDate: undefined});
  }

  async refreshCsvExports() {
    await exportsModule.getCsvExportsFiles({fromDate: undefined});
  }

  async downloadStatusExport(item: DataExchangeFileDto) {
    const {fileName} = item;

    await exportsModule.downloadStatusExport({fileName: fileName!})
        .then(response => {
          if (response) {
            startDownload(response.data, fileName!);
          }
        }).catch(console.error)
  }

  async downloadChangesExport(item: DataExchangeFileDto) {
    const {fileName} = item;

    await exportsModule.downloadChangesExport({fileName: fileName!})
        .then(response => {
          if (response) {
            startDownload(response.data, fileName!);
          }
        }).catch(console.error)
  }

  async downloadCsvExport(item: DataExchangeFileDto) {
    const {fileName} = item;

    await exportsModule.downloadCsvExport({fileName: fileName!})
        .then(response => {
          if (response) {
            startDownload(response.data, fileName!);
          }
        }).catch(console.error)
  }

  get canGenerateStatusExport() {
    return currentUserModule.hasRight(Rights.AkromegalieStatusExportGetCmd);
  }

  get canGenerateChangesExport() {
    return currentUserModule.hasRight(Rights.ChangesExportCmd);
  }

  get canGenerateCsvExport() {
    return currentUserModule.hasRight(Rights.ExportGetCsvCmd);
  }

  get canGetStatusExportFiles() {
    return currentUserModule.hasRight(Rights.AkromegalieStatusExportGetFilesCmd);
  }

  get canGetChangesExportFiles() {
    return currentUserModule.hasRight(Rights.ChangesExportGetFilesCmd);
  }

  get canGetCsvExportFiles() {
    return currentUserModule.hasRight(Rights.StudyCsvExportGetFilesCmd);
  }

  get canDownloadStatusExportFiles() {
    return currentUserModule.hasRight(Rights.AkromegalieStatusExportGetFileCmd);
  }

  get canDownloadChangesExportFiles() {
    return currentUserModule.hasRight(Rights.ChangesExportGetFileCmd);
  }

  get canDownloadCsvExportFiles() {
    return currentUserModule.hasRight(Rights.StudyCsvExportGetFileCmd);
  }

}
